import {Component, computed, input, model} from '@angular/core';
import {IFieldConfig} from '../../../types/IVendor';
import {Text} from '../text/text';
import {Number} from '../number/number';
import {SelectComponent} from '../select/select.component';
import {Alert} from '../alert/alert';

@Component({
  selector: 'app-dynamic-field-form',
  imports: [Text, Number, SelectComponent, Alert],
  templateUrl: './dynamic-field-form.html',
  styleUrl: './dynamic-field-form.css',
})
export class DynamicFieldFormComponent {
  fields = input.required<Record<string, IFieldConfig>>();
  required = input<string[]>([]);
  values = model<Record<string, any>>({});
  notes = input<string[]>([]);

  fieldEntries = computed(() => Object.entries(this.fields()));

  updateField(key: string, value: any): void {
    this.values.update(current => ({...current, [key]: value}));
  }

  isRequired(key: string): boolean {
    return this.required().includes(key);
  }

  getFieldValue(key: string): any {
    return this.values()[key] ?? '';
  }

  getOptions(options: Record<string, string> | null): Array<{value: string; label: string}> {
    if (!options) return [];
    return Object.entries(options).map(([value, label]) => ({value, label}));
  }
}
